import React, { useEffect, useState } from 'react';
import { FaEdit, FaPlus, FaTrash, FaToggleOff, FaToggleOn } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import AdminSideMenu from '../../components/AdminSideMenu';
import api from "../../utils/axiosInstance";

const Packages = () => {
    const [packages, setPackages] = useState([]);

    useEffect(() => {
        fetchPackages();
    }, []);

    const fetchPackages = async () => {
        try {
            const res = await api.get('/packages');
            setPackages(res.data);
        } catch (err) {
            console.error('Failed to fetch packages:', err);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this package?')) return;
        try {
            await api.delete(`/packages/${id}`);
            fetchPackages();
        } catch (err) {
            alert('Failed to delete package');
            console.error(err);
        }
    };

    const handleToggleStatus = async (id) => {
        try {
            const res = await api.put(`/packages/toggle-status/${id}`);
            alert(res.data.message);
            fetchPackages(); // refresh
        } catch (err) {
            console.error('Toggle status error:', err.message);
            alert('Failed to update status');
        }
    };

    return (
        <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
            <AdminSideMenu />

            <div className="w-full md:ml-64 p-4 sm:p-6 lg:p-8">
                {/* Header */}
                <header className="mb-8">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900">Packages</h1>
                            <p className="text-gray-600">Manage your subscription packages.</p>
                        </div>
                        <Link
                            to="/admin/create-package"
                            className="bg-blue-primary text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-dark hover:shadow-lg flex items-center transition"
                            style={{ backgroundColor: '#3c9bf9' }}
                        >
                            <FaPlus className="mr-2" /> Add Package
                        </Link>
                    </div>
                </header>

                {/* Packages Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 items-stretch">
                    {packages.length === 0 ? (
                        <div className="col-span-full text-center text-gray-500 text-lg py-12">
                            No records found
                        </div>
                    ) : (
                        packages.map((pkg) => (
                            <div
                                key={pkg._id}
                                className="relative h-full flex flex-col bg-white shadow-lg hover:shadow-xl hover:-translate-y-1 hover:scale-[1.01] transition rounded-3xl overflow-hidden"
                            >
                                {/* Header */}
                                <div className="bg-blue-700 py-6 text-center text-white">
                                    <div className="text-lg font-bold">{pkg.name}</div>
                                    <div className="text-4xl font-extrabold">
                                        {typeof pkg.price === 'number' ? `$${pkg.price}` : pkg.price}
                                    </div>
                                </div>

                                {/* Body */}
                                <div className="flex-1 flex flex-col px-6 py-6">
                                    <ul className="mb-6 space-y-3 text-gray-700 text-sm">
                                        {pkg.features?.map((feature, i) => (
                                            <li key={i} className="flex items-center">
                                                <span className="mr-2">{pkg.iconList?.[i] || '✔️'}</span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="mt-auto">
                                        <div className="text-xs text-gray-400 mb-4">
                                            Status: <span className={pkg.isActive ? 'text-green-600' : 'text-blue-600'}>
                                                {pkg.isActive ? 'Active' : 'Inactive'}
                                            </span>
                                        </div>
                                        {/* Action Buttons at Bottom */}
                                        <div className="flex justify-end gap-2 mt-4">
                                            {/* Edit */}
                                            <Link
                                                to={`/admin/package/edit/${pkg._id}`}
                                                className="bg-black text-white rounded-full w-9 h-9 flex items-center justify-center hover:bg-blue-600 transition"
                                                title="Edit"
                                            >
                                                <FaEdit />
                                            </Link>

                                            {/* Toggle Status */}
                                            <button
                                                onClick={() => handleToggleStatus(pkg._id)}
                                                className="bg-black text-white rounded-full w-9 h-9 flex items-center justify-center hover:bg-blue-600 transition"
                                                title={pkg.isActive ? 'Deactivate' : 'Activate'}
                                            >
                                                {pkg.isActive ? <FaToggleOn /> : <FaToggleOff />}
                                            </button>

                                            {/* Delete */}
                                            <button
                                                onClick={() => handleDelete(pkg._id)}
                                                className="bg-black text-white rounded-full w-9 h-9 flex items-center justify-center hover:bg-blue-600 transition"
                                                title="Delete"
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>


            </div>
        </div>
    );
};

export default Packages;
